export const ADD_ONS = {
  AI_INSIGHTS: 'AI_INSIGHTS',
  DISABLE_INLINE_LABELS: 'DISABLE_INLINE_LABELS',
  COMPACT_CARD: 'COMPACT_CARD',
  DISABLE_CARD_WRAPPER: 'DISABLE_CARD_WRAPPER',
  SUMMARY_DATAWELL: 'SUMMARY_DATAWELL',
  EDITORS_BAR: 'EDITORS_BAR',
  VIEW_SRV: 'VIEW_SRV',
  COPILOT_INSIGHTS: 'COPILOT_INSIGHTS',
  DISABLE_DRILLDOWN: 'DISABLE_DRILLDOWN',
  DISABLE_LAZY_REPORT_RESOLVE: 'DISABLE_LAZY_REPORT_RESOLVE',
  DATA_TABLES: 'DATA_TABLES',
  TABLE_LIMIT_10: 'TABLE_LIMIT_10',
  DISABLE_EXPORT: 'DISABLE_EXPORT',
  // only valid for config reports and needs REPORTING_ENABLEMENT_SRV_REPORT_PRESETS_GATE and access to report insights
  AI_REPORT_REMIX: 'AI_REPORT_REMIX'
};
export const REPORT_ACTIONS = {
  SAVE_REPORT: 'SAVE_REPORT',
  EXPORT_REPORT: 'EXPORT_REPORT',
  CUSTOMIZE_REPORT: 'CUSTOMIZE_REPORT'
};

// Do not change values - must match css classes in ReportCardV2.tsx
export const DISPLAY_MODES = {
  DEFAULT: 'default',
  DASHBOARD: 'dashboard'
};
export const WRAPPER_USE = {
  CARD: 'CARD',
  TILE: 'TILE'
};